import { TMaintenanceEventType } from './calendar.types'

const calendarDays: Record<string, string> = {
  января: 'январь',
  февраля: 'февраль',
  марта: 'март',
  апреля: 'апрель',
  мая: 'май',
  июня: 'июнь',
  июля: 'июль',
  августа: 'август',
  сентября: 'сентябрь',
  октября: 'октябрь',
  ноября: 'ноябрь',
  декабря: 'декабрь',
}

const maintenanceEventTypes: Record<TMaintenanceEventType, string> = {
  PLANNED_MAINTENANCE: 'Запланировано',
  OVERDUE_MAINTENANCE: 'Просрочено',
  COMPLETED_MAINTENANCE: 'Выполнено',
  NO_RESPONSIBLE: 'Без ответственного',
}

const calendarPageConstants = { calendarDays, maintenanceEventTypes }
export default calendarPageConstants
